import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .progress-circle {
    width: 100px;
    height: 100px;
    background-color: #ffffff;
    border-radius: 50%;
    position: relative;
    &.hovered-hide {
      opacity: 0.3;
    }
    &:hover {
      opacity: 1;
    }
  }
  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .hover-information {
    display: none;
    width: 200px;
    height: fit-content;
    padding: 0.5rem;
    border-radius: 24px;
    color: #fff;
    background: #000;
    position: absolute;
    bottom: 100%;
    right: -50%;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    flex-direction: column;
    p {
      margin: 0;
      font-size: 14px;
    }
  }
  &:hover > .hover-information {
    display: flex;
  }
`;
